<template>
  <div>
    <v-text-field
      :id="id"
      v-model="fileName"
      :label="label"
      :error-messages="errorMessages"
      :hide-details="hideDetails"
      :hint="hint"
      :persistent-hint="!!hint"
      readonly
      :prepend-inner-icon="$getIcon('mdiAttachment')"
      :append-icon="$getIcon('mdiWindowClose')"
      @click:prepend="pickFile"
      @click:append="clear()"
      @click="pickFile"
      @blur="$emit('blur')"
    ></v-text-field>
    <input
      id="fileUpload"
      ref="upload"
      type="file"
      class="d-none"
      multiple="multiple"
      @change="upload"
    />
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, File],
      default: undefined
    },
    default: {
      type: [String, File],
      default: undefined
    },
    text: {
      type: String,
      default: undefined
    },
    id: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "Browse file from here"
    },
    hint: {
      type: String,
      default: undefined
    },
    errors: {
      type: [String, Array],
      default() {
        return [];
      }
    },
    errorMessages: {
      type: [String, Array],
      default() {
        return [];
      }
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileName: this.value
    };
  },
  watch: {
    default: {
      handler(val) {
        if (val && !(val instanceof File)) this.fileName = val;
      },
      immediate: true
    },
    value(val) {
      if (!val) this.fileName = "";
      document.getElementById("fileUpload").value = null;
      this.fileName = val;
    }
  },
  methods: {
    pickFile() {
      this.$refs.upload.click();
    },
    async upload(file) {
      let blobFile = file.target.files[0];
      this.imageName = blobFile.name;
      const validExtensions = [
        "doc",
        "docx",
        "odt",
        "pdf",
        "xls",
        "xlsx",
        "ods",
        "ppt",
        "pptx",
        "txt",
        "tif",
        "tiff",
        "gif",
        "jpeg",
        "jpg",
        "jif",
        "jfif",
        "jp2",
        "jpx",
        "j2k",
        "j2c",
        "fpx",
        "pcd",
        "png",
        "csv"
      ];
      const fileName = blobFile.name.substr(0);
      const extension = fileName.split(".").pop();
      if (
        file.target.files[0].size < 5 * 1024 * 1024 &&
        validExtensions.includes(extension)
      ) {
        this.$emit("update", blobFile);
        this.$emit("input", blobFile.name);
      } else {
        this.fileName = null;
        this.$emit("input", this.fileName);
        this.$store.dispatch("shell/showSnackbar", {
          text: !validExtensions.includes(extension)
            ? `Invalid Extensions, Supported Extensions are ${validExtensions.toString()}`
            : `File size cannot be greater than 5MB.`,
          color: "red"
        });
      }
    },
    clear() {
      this.$emit("input", "");
      this.$emit("update", "");
    }
  }
};
</script>
